import type { Properties } from './types'

export const reservedKeys = new Set(['__proto__', 'constructor', 'prototype'])

export function warnAboutEvent(
  name: string,
  properties: Properties | undefined,
): void {
  const problems: string[] = []
  if (!name.trim()) {
    problems.push('an event name is empty')
  }
  if (name.startsWith('$')) {
    problems.push(`event names starting with $ are reserved: ${name}`)
  }
  if (name.length > 200) {
    problems.push(`an event name is longer than 200 characters: ${name}`)
  }
  const entries = Object.entries(properties ?? {})
  if (entries.length > 30) {
    problems.push(`${name} has more than 30 properties`)
  }
  for (const [key, value] of entries) {
    if (key.startsWith('$') || key.length > 128 || reservedKeys.has(key)) {
      problems.push(`${name}: property key not allowed: ${key}`)
    } else if (
      value !== undefined &&
      typeof value !== 'string' &&
      typeof value !== 'number' &&
      typeof value !== 'boolean'
    ) {
      problems.push(`${name}: ${key} must be a string, number or boolean`)
    } else if (typeof value === 'string' && value.length > 2000) {
      problems.push(`${name}: ${key} is longer than 2,000 characters`)
    }
  }
  for (const problem of problems) {
    console.warn(`[loomduct] ${problem}`)
  }
}
